/**
 * Google Analytics tracking composable
 * Provides methods to track user interactions with buttons and other events
 */
export const useAnalytics = () => {
    const trackButtonClick = (buttonName: string, category = 'button', additionalData?: Record<string, any>) => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'click', {
                event_category: category,
                event_label: buttonName,
                button_name: buttonName,
                ...additionalData
            });
        }
    };

    const trackPageView = (pageName: string, additionalData?: Record<string, any>) => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'page_view', {
                page_title: pageName,
                ...additionalData
            });
        }
    };

    const trackOptimization = (action: string, strategy?: string, additionalData?: Record<string, any>) => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', action, {
                event_category: 'optimization',
                strategy_used: strategy,
                ...additionalData
            });
        }
    };

    const trackExport = (exportType: string, additionalData?: Record<string, any>) => {
        if (typeof window !== 'undefined' && window.gtag) {
            window.gtag('event', 'export', {
                event_category: 'export',
                export_type: exportType,
                ...additionalData
            });
        }
    };

    return {
        trackButtonClick,
        trackPageView,
        trackOptimization,
        trackExport
    };
};

// Global type declaration for gtag
declare global {
    interface Window {
        gtag: (command: string, targetId: string, config?: any) => void;
    }
}
